import {Component, forwardRef, Input, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {IonTextarea} from '@ionic/angular';

@Component({
  selector: 'sm-textarea',
  templateUrl: './sm-textarea.component.html',
  styleUrls: ['./sm-textarea.component.scss'],
  standalone: false,
  providers: [{provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SmTextareaComponent), multi: true}],
})
export class SmTextareaComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() ariaLabel = '';
  @Input() placeholder = '';
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() invalid = false;
  @Input() errorText = '';
  @Input() autoGrow = false;
  @ViewChild(IonTextarea) private readonly ionTextarea?: IonTextarea;

  value = '';
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string | null): void { this.value = value ?? ''; }
  registerOnChange(fn: (value: string) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { this.disabled = isDisabled; }

  handleInput(event: CustomEvent<{value?: string | null}>): void {
    this.value = event.detail.value ?? '';
    this.onChange(this.value);
  }

  handleBlur(): void { this.onTouched(); }
  async focus(): Promise<void> { await this.ionTextarea?.setFocus(); }
}
